import {
  useAnalyticsBreakdownQuery,
  useAnalyticsEventsQuery,
  useAnalyticsTimeSeriesQuery,
  useAnalyticsTopEventsQuery,
  type AnalyticsBreakdownDimension,
  type AnalyticsDateRangeInput,
  type AnalyticsGranularity,
} from "@/graphql/generated";

/**
 * Thin wrappers over the codegen'd analytics hooks. Each uses
 * `cache-and-network` (matches the dashboard) and skips while no event is
 * selected. These are ADMIN-only queries server-side.
 */

export function useAnalyticsEvents() {
  return useAnalyticsEventsQuery({ fetchPolicy: "cache-and-network" });
}

export function useAnalyticsTimeSeries(params: {
  event: string;
  range: AnalyticsDateRangeInput;
  granularity: AnalyticsGranularity;
  skip?: boolean;
}) {
  return useAnalyticsTimeSeriesQuery({
    variables: { event: params.event, range: params.range, granularity: params.granularity },
    skip: params.skip ?? params.event === "",
    fetchPolicy: "cache-and-network",
  });
}

export function useAnalyticsBreakdown(params: {
  event: string;
  range: AnalyticsDateRangeInput;
  dimension: AnalyticsBreakdownDimension;
  skip?: boolean;
}) {
  return useAnalyticsBreakdownQuery({
    variables: { event: params.event, range: params.range, dimension: params.dimension },
    skip: params.skip ?? params.event === "",
    fetchPolicy: "cache-and-network",
  });
}

export function useAnalyticsTopEvents(params: {
  range: AnalyticsDateRangeInput;
  limit: number;
}) {
  return useAnalyticsTopEventsQuery({
    variables: { range: params.range, limit: params.limit },
    fetchPolicy: "cache-and-network",
  });
}
